import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { MailIcon, PhoneIcon, MapPinIcon, SendIcon } from 'lucide-react';
import { useForm, ValidationError } from '@formspree/react';
export function Contact() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const [state, handleSubmit] = useForm('xwpkglvj');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    language: '',
    message: '',
    _replyto: 'thelanguagemagnateacademy@gmail.com'
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  useEffect(() => {
    if (state.succeeded) {
      setFormData({
        name: '',
        email: '',
        language: '',
        message: '',
        _replyto: 'thelanguagemagnateacademy@gmail.com'
      });
    }
  }, [state.succeeded]);
  return <section id="contact" className="py-24 bg-white" data-id="element-44">
      <div className="max-w-7xl mx-auto px-6" data-id="element-45">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 50
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-46">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-47">
            Get in <span className="text-green-600" data-id="element-48">Touch</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-49">
            Ready to start your language journey? Contact us today for a free
            consultation
          </p>
        </motion.div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-50">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8
        }} data-id="element-51">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-52">
              <input type="hidden" name="_replyto" value="thelanguagemagnateacademy@gmail.com" data-id="element-53" />
              <div data-id="element-54">
                <label htmlFor="name" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-55">
                  Full Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" placeholder="John Doe" data-id="element-56" />
                <ValidationError prefix="Name" field="name" errors={state.errors} data-id="element-57" />
              </div>
              <div data-id="element-58">
                <label htmlFor="email" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-59">
                  Email Address
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" placeholder="john@example.com" data-id="element-60" />
                <ValidationError prefix="Email" field="email" errors={state.errors} data-id="element-61" />
              </div>
              <div data-id="element-62">
                <label htmlFor="language" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-63">
                  Language of Interest
                </label>
                <select id="language" name="language" value={formData.language} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" data-id="element-64">
                  <option value="" data-id="element-65">Select a language</option>
                  <option value="french" data-id="element-66">French</option>
                  <option value="english" data-id="element-67">English</option>
                  <option value="german" data-id="element-68">German</option>
                  <option value="spanish" data-id="element-69">Spanish</option>
                </select>
                <ValidationError prefix="Language" field="language" errors={state.errors} data-id="element-70" />
              </div>
              <div data-id="element-71">
                <label htmlFor="message" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-72">
                  Message
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none resize-none disabled:bg-slate-100" placeholder="Tell us about your language learning goals..." data-id="element-73" />
                <ValidationError prefix="Message" field="message" errors={state.errors} data-id="element-74" />
              </div>
              <button type="submit" disabled={state.submitting} className="w-full bg-green-600 text-white py-4 rounded-lg font-semibold hover:bg-green-700 transition-all duration-200 flex items-center justify-center gap-2 shadow-lg hover:shadow-xl disabled:bg-slate-400 disabled:cursor-not-allowed" data-id="element-75">
                {state.submitting ? 'Sending...' : state.succeeded ? 'Message Sent Successfully!' : <>
                    Send Message
                    <SendIcon size={20} data-id="element-76" />
                  </>}
              </button>
              {state.succeeded && <p className="text-green-600 text-center" data-id="element-77">
                  Thank you for your message! We'll get back to you soon.
                </p>}
            </form>
          </motion.div>
          {/* Contact Information */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-78">
            <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-8 text-white" data-id="element-79">
              <h3 className="text-2xl font-bold mb-6" data-id="element-80">Contact Information</h3>
              <div className="space-y-6" data-id="element-81">
                <div className="flex items-start gap-4" data-id="element-82">
                  <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-83">
                    <MailIcon size={24} data-id="element-84" />
                  </div>
                  <div data-id="element-85">
                    <div className="font-semibold mb-1" data-id="element-86">Email</div>
                    <a href="mailto:thelanguagemagnateacademy@gmail.com" className="text-slate-300 hover:text-green-400 transition-colors duration-200" data-id="element-87">
                      thelanguagemagnateacademy@gmail.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-88">
                  <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-89">
                    <PhoneIcon size={24} data-id="element-90" />
                  </div>
                  <div data-id="element-91">
                    <div className="font-semibold mb-1" data-id="element-92">Phone</div>
                    <a href="tel:+337080358367" className="text-slate-300 hover:text-green-400 transition-colors duration-200" data-id="element-93">
                      +33 7 08 03 58 36 7
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-94">
                  <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-95">
                    <MapPinIcon size={24} data-id="element-96" />
                  </div>
                  <div data-id="element-97">
                    <div className="font-semibold mb-1" data-id="element-98">Location</div>
                    <p className="text-slate-300" data-id="element-99">
                      Aix-en-Provence
                      <br data-id="element-100" />
                      France
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-slate-50 rounded-3xl p-8" data-id="element-101">
              <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-102">
                Office Hours
              </h3>
              <div className="space-y-2 text-slate-600" data-id="element-103">
                <p data-id="element-104">Monday - Friday: 9:00 AM - 7:00 PM</p>
                <p data-id="element-105">Saturday: 10:00 AM - 4:00 PM</p>
                <p data-id="element-106">Sunday: Closed</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}